module.exports = __webpack_public_path__ + "img/SBLI_BW-img-desktop.af529527.svg";